// src/auth/jwt.js
export function parseJwt(token) {
  try {
    const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(b64).split('').map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`).join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function currentAdminId() {
  // const token = localStorage.getItem('jwt') || sessionStorage.getItem('jwt');
  // if (!token) return null;
  // const p = parseJwt(token);
  // // support several claims
  // return p?.admin_id ?? p?.sub ?? p?.uid ?? p?.id ?? null;
  return localStorage.getItem('adminId') || null;
}
